import React from 'react';
import c from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';

import ArticleMetadata from '../ArticleMetadata';
import Card from '../Card';
import { ArticleCardProps } from '../Card/types';
import Tag from '../Tag';

import './style.scss';

const ArticleCard: React.FC<ArticleCardProps> = (props) => {
  const {
    title,
    tags,
    image,
    subtitle,
    link,
    readTime,
    publicationDate,
    className,
  } = props;

  const classNames = c('ArticleCard', 'u-focus-ring--within', 'u-link-box', className);

  return (
    <Card className={classNames}>
      {(tags && tags.length > 0) && (
        <div className="ArticleCard__tags">
          {tags.map((tag, index) => (
            <Tag
              key={`tag:${tag.type}:${index + 1}`}
              type={tag.type}
              name={tag.name}
            />
          ))}
        </div>
      )}

      <Card.Content>
        <CoreLink href={link}>
          <Card.Title title={title} />
        </CoreLink>

        <Card.Subtitle subtitle={subtitle} />

        <ArticleMetadata className="ArticleCard__metadata">
          {readTime && (
            <ArticleMetadata.ReadTime readTime={readTime} />
          )}
          {publicationDate && (
            <ArticleMetadata.PublicationDate publicationDate={publicationDate} />
          )}
        </ArticleMetadata>
      </Card.Content>

      <Card.Image image={image} />
    </Card>
  );
};

export default ArticleCard;
